import styled from 'styled-components'
import { Colors, Spacing, Typography } from 'cio-design-library/design-tokens'
import Media from 'builder/styles/media'
import { Icon20 } from 'builder/components/Icon'
import Spinner from 'builder/components/Spinner'
import { ButtonV2 } from 'builder/components/Button'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const KeywordsHeader = styled.div`
  display: flex;
  align-items: center;
  gap: ${Spacing.S};

  ${Media.Phone`
    flex-direction: column;
    align-items: start;
  `};
`

export const JobTitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${Spacing.S};
  align-items: center;
  flex: 1 1 auto;
  min-width: 0;

  ${Media.Phone`
    flex: 0 0 100%;
    width: 100%;
  `};
`

export const JobTitleWrapper = styled.div`
  display: flex;
  gap: ${Spacing['2XS']};
  flex-wrap: nowrap;
  min-width: 0;
`

export const JobTitle = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const Action = styled.button`
  ${Typography.sizes.ButtonS};
  font-weight: ${Typography.weights.medium};
  margin: 0;
  padding: 0;
  border: none;
  outline: none;
  color: ${Colors.Blue50};
  transition: color 0.1s ease-out;
  cursor: pointer;
  white-space: nowrap;

  ${Media.Hover`
    &:hover {
      color: ${Colors.Blue60};
    }
  `}
`

export const CounterContainer = styled.div`
  display: flex;
  gap: ${Spacing.S};
  align-items: center;
`

export const KeywordsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4px;

  ${Media.Phone`
    grid-template-columns: 1fr;
  `};
`

export const Footer = styled.div`
  display: flex;
  gap: ${Spacing.XS};
`

export const StyledButton = styled(ButtonV2)`
  flex: 1 1 50%;
`

export const ArrowTargetIcon = styled(Icon20.ArrowTarget2)`
  width: 24px;
  height: 24px;
`

export const LoaderContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`

export const Loader = styled(Spinner)`
  width: 24px;
  height: 24px;
`
